"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.STATUS_COLOR = exports.STATUS_CLOSED = void 0;
exports.STATUS_CLOSED = "'closed'";
exports.STATUS_COLOR = "'#ffffff'";
